import * as R from 'ramda'
import moment from 'moment'

export default function getDefaultDueDate(doc) {
  const end = R.path(['end'], doc)

  if (R.isNil(end)) return null
  if (!moment(end).isValid()) return null

  return moment(end).add('months', 1).date(8).toDate()
}
